import * as yup from 'yup';

import { MAX_NAME_LENGTH } from '@/constants/profile';

export const editProfileSchema = yup.object().shape({
  image: yup
    .mixed<File>()
    .defined()
    .nullable()
    .test('fileType', 'Only image files are allowed', (file) => {
      return !file || file.type.startsWith('image/');
    }),
  isImageDeleted: yup.boolean().defined(),
  name: yup.string().max(MAX_NAME_LENGTH).required('Name is required'),
  country: yup.string().defined(),
  state: yup.string().defined(),
  city: yup.string().defined(),
  skills: yup.array().defined(),
  openToCollaborate: yup.boolean().defined(),
  primaryTeam: yup
    .object()
    .shape({
      value: yup.string().defined(),
      label: yup.string().defined(),
      // role: yup.string().defined(),
    })
    .nullable()
    .defined(),
  primaryTeamRole: yup.string().defined().nullable(),
  bio: yup.string().max(2000, 'Bio must be less than 2000 characters').defined(),
  newTeamRole: yup.string().default('').when('$isAddingTeamInline', {
    is: true,
    then: (schema) => schema.required('Role is required'),
    otherwise: (schema) => schema.defined(),
  }),
  newTeamName: yup.string().default('').when('$isAddingTeamInline', {
    is: true,
    then: (schema) => schema.required('Team name is required'),
    otherwise: (schema) => schema.defined(),
  }),
  newTeamWebsite: yup.string().default('').when('$isAddingTeamInline', {
    is: true,
    then: (schema) => schema.required('Website is required'),
    otherwise: (schema) => schema.defined(),
  }),
});
